import React, { useRef, useState, useEffect } from "react";
import {
    I2cRadioGroup, I2cRadioButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { Controller } from "react-hook-form";
import { CheckboxRenderer, InputRenderer, CheckboxTableRenderer, HeaderCheckboxRenderer } from "./CellRenderer";
import { I2cDataTable } from '@webcomponents/i2cwebcomponents/dist/react';
import { loginInfo, accountInfo, additionalCardInfo, documentationInfo, employeeInfo, businessOwnerInfo, businessInfo } from './stringUtils';
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"

const CorporateDataTables = ({ type, control, handleValueChanges, methods, errors, appSelectionForProgram, isFormDataUpdated }) => {
    const [gridOptionsLoginInfo, setGridOptionsLoginInfo] = useState({});
    const [gridOptionsBusinessInfo, setGridOptionsBusinessInfo] = useState({});
    const [gridOptionsOwnerInfo, setGridOptionsOwnerInfo] = useState({});
    const [gridOptionsEmployeeInfo, setGridOptionsEmployeeInfo] = useState({});
    const [gridOptionsDocumentation, setGridOptionsDocumentation] = useState({});
    const [gridOptionsCardInfo, setGridOptionsCardInfo] = useState({});
    const [gridOptionsAccountInfo, setGridOptionsAccountInfo] = useState({});

    const tableRefs = {
        corporate_login_info: useRef(null),
        corporate_business_info: useRef(null),
        corporate_business_owner_info: useRef(null),
        corporate_employee_info: useRef(null),
        corporate_documentation: useRef(null),
        corporate_additional_card_info: useRef(null),
        corporate_account_info: useRef(null),
    };

    const tables = [
        { id: 'corporate_login_info', dataKey: 'card_enrollment_fields_for_corporate_login_info', tableName: "Login Information", initialData: loginInfo, stateSetter: setGridOptionsLoginInfo },
        { id: 'corporate_business_info', dataKey: 'card_enrollment_fields_for_corporate_business_info', tableName: "Business Information", initialData: businessInfo, stateSetter: setGridOptionsBusinessInfo },
        { id: 'corporate_business_owner_info', dataKey: 'card_enrollment_fields_for_corporate_business_owner_info', tableName: "Business Owner Information", initialData: businessOwnerInfo, stateSetter: setGridOptionsOwnerInfo },
        { id: 'corporate_employee_info', dataKey: 'card_enrollment_fields_for_corporate_employee_info', tableName: "Employee Information", initialData: employeeInfo, stateSetter: setGridOptionsEmployeeInfo },
        { id: 'corporate_documentation', dataKey: 'card_enrollment_fields_for_corporate_documentation', tableName: "Documentation", initialData: documentationInfo, stateSetter: setGridOptionsDocumentation },
        { id: 'corporate_additional_card_info', dataKey: 'card_enrollment_fields_for_corporate_additional_card_info', tableName: "Additional Card Info", initialData: additionalCardInfo, stateSetter: setGridOptionsCardInfo },
        { id: 'corporate_account_info', dataKey: 'card_enrollment_fields_for_corporate_account_info', tableName: "Account Information", initialData: accountInfo, stateSetter: setGridOptionsAccountInfo },
    ];
    useEffect(() => {
        tables.forEach((table) => {
            const backendData = methods.getValues(table.dataKey);
            const gridOptions = (backendData?.length > 0 ?
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: CheckboxTableRenderer, headerComponent: HeaderCheckboxRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: backendData,
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
                :
                {
                    columnDefs: [
                        { headerName: 'Enrollment Field', field: 'enrollment_field', editable: true },
                        { headerName: 'Enable', field: 'enable', cellRenderer: InputRenderer },
                        { headerName: 'Mandatory', field: 'mandatory', cellRenderer: InputRenderer }
                    ],
                    rowSelection: 'single',
                    rowData: table.initialData || [],
                    suppressMoveWhenRowDragging: true,
                    context: { methods, handleValueChanges, tableType: table.dataKey }
                }
            );
            table.stateSetter(gridOptions);
            const api = tableRefs[table.id]?.current?.getGridApi();
            if (api) {
                api.setRowData && api.setRowData(backendData?.length > 0 ? backendData : table.initialData || []);
            }
        });
    }, [isFormDataUpdated]);

    return (
        <>
            <div i2c-grid="grid gap-md">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Corporate Enrollment (For the Web App only)
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="custom-label mb-8">
                        Please select enrollment fields for business credit programs.
                    </div>
                    <div className="section-tables-containers">
                        <div i2c-grid="grid gap-md">
                            {tables.map((table) => (
                                <>
                                    <div i2c-grid="12" className="cholder-label-heading">
                                        {table.tableName}
                                    </div>
                                    <div i2c-grid="12">
                                        <Controller
                                            key={table.id}
                                            name={table.dataKey}
                                            control={control}
                                            render={({ field }) => (
                                                <I2cDataTable
                                                    id={`dataTable_${table.id}`}
                                                    ref={tableRefs[table.id]}
                                                    gridOptionInput={
                                                        table.id === 'corporate_login_info' ? gridOptionsLoginInfo :
                                                            table.id === 'corporate_business_info' ? gridOptionsBusinessInfo :
                                                                table.id === 'corporate_business_owner_info' ? gridOptionsOwnerInfo :
                                                                    table.id === 'corporate_employee_info' ? gridOptionsEmployeeInfo :
                                                                        table.id === 'corporate_documentation' ? gridOptionsDocumentation :
                                                                            table.id === 'corporate_additional_card_info' ? gridOptionsCardInfo :
                                                                                gridOptionsAccountInfo  // For 'corporate_account_info'
                                                    }
                                                    notFound={[
                                                        {
                                                            description: 'No data available. Please add some features or refresh the page.',
                                                            type: 'noData',
                                                            icon: 'outline-info-circle',
                                                            primaryBtn: `<i2c-button variant="primary" size='large'>Reload</i2c-button>`,
                                                        },
                                                    ]}
                                                />
                                            )}
                                        />
                                    </div>
                                </>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CorporateDataTables;                  
